<div *ngIf="!valueOnly">
  <ion-list>
  <ion-item
  *ngIf="!valueOnly" class="question-item">
    <div class="question-item-content" *ngIf="description !== undefined">
      <h2>{{title}}</h2>
      <p class="description">{{description}}</p>
      <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
    </div>
    <div class="question-item-content" *ngIf="description === undefined">
      <div class="question-text">{{title}}</div>
      <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
    </div>
  </ion-item>
  </ion-list>
</div>
<div *ngIf=valueOnly>
  <ng-container *ngTemplateOutlet="tempOutlet"></ng-container>
</div>

<ng-template #tempOutlet>
  <ng-content></ng-content>
</ng-template>
